export type AtendabotWhatsAppStatus = {
  configured?: boolean;
  connected?: boolean;
  smartphoneConnected?: boolean;
  status?: string;
  provider_status?: string | null;
  phone_number?: string | null;
  suggested_phone_number?: string | null;
  connected_phone?: string | null;
  phone_mismatch?: boolean;
  trial_expires_at?: string | null;
  is_subscribed?: boolean;
  phone_change_allowed?: boolean;
  instance_unavailable?: boolean;
  changed?: boolean;
  error?: string | null;
};

const UNAVAILABLE_INSTANCE_STATUSES = new Set([
  'CANCELADA',
  'CANCELED',
  'CANCELLED',
  'DISABLED',
  'EXPIRADA',
  'EXPIRED',
  'INACTIVE',
]);

export const WHATSAPP_INSTANCE_UNAVAILABLE_MESSAGE =
  'Houve um problema com a conexão do WhatsApp. Entre em contato com o suporte.';

export const isAtendabotWhatsAppUnavailable = (
  status?: AtendabotWhatsAppStatus | null,
) => {
  if (status?.instance_unavailable === true || status?.error === 'instance_unavailable') return true;
  const providerStatus = String(status?.provider_status || '').trim().toUpperCase();
  const localStatus = String(status?.status || '').trim().toUpperCase();
  return UNAVAILABLE_INSTANCE_STATUSES.has(providerStatus)
    || UNAVAILABLE_INSTANCE_STATUSES.has(localStatus);
};

export const isAtendabotWhatsAppUnavailableError = (error: any) => (
  ['ZAPI_INSTANCE_UNAVAILABLE', 'UAZAPI_INSTANCE_UNAVAILABLE'].includes(error?.response?.data?.code)
);

export const ATENDABOT_WHATSAPP_STATUS_EVENT = 'atendabot:whatsapp-status-changed';

export const notifyAtendabotWhatsAppStatus = (status: AtendabotWhatsAppStatus) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ATENDABOT_WHATSAPP_STATUS_EVENT, {
    detail: status,
  }));
};
